import { Controller, MobileContextMenu } from '@tencent/workbench';
import { HideSlideFeature } from './hide-slide.feature';
import { MOBILE_CONTEXTMENU_ITEMS, hideSlideConfig, cancelHideSlideConfig } from './config';

@Controller({
    mobileContextMenuItems: MOBILE_CONTEXTMENU_ITEMS,
})
export class HideSlideController {
    public constructor(private readonly feature: HideSlideFeature) {}

    @MobileContextMenu(hideSlideConfig.name, 'onClick')
    public onHideSlideClick(): void {
        this.feature.hideSlides();
    }

    @MobileContextMenu(hideSlideConfig.name, 'shouldHide')
    public shouldHideSlideHide(): boolean {
        return this.feature.shouldHideHideSlideButton();
    }

    @MobileContextMenu(cancelHideSlideConfig.name, 'onClick')
    public onCancelHideSlideClick(): void {
        this.feature.showSlides();
    }

    @MobileContextMenu(cancelHideSlideConfig.name, 'shouldHide')
    public shouldHideCancelSlideHide(): boolean {
        return this.feature.shouldHideCancelHideSlideButton();
    }
}
